//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { WHEEL_MULTIPLIERS_COLORS } from './wheel.entity';

export default {
  name: 'WheelHistoryRoundColors',
  props: {
    colors: {
      type: Array,
      required: true,
      default: () => []
    },
    winColor: {
      type: [Number, String],
      required: true
    },
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 对应 Pipe: MultiplierColorPipe
    getMultiplierColor(id) {

      return WHEEL_MULTIPLIERS_COLORS[id] || 'blue';
    },

    // 对应 Pipe: MultiplierRatioPipe 及 StreamerModeMultiplierPipe
    getMultiplierRatio(id) {
      if (this.streamerMode) {
        return `x${id}`;
      }
      return `x${id}`;
    },

    // 格式化数值
    formatBank(val) {
      if (typeof val !== 'number') return '0.00';
      return val.toFixed(2);
    }
  }
};
